export default function(val) {
  if (val > 0) return 'red'
  if (val < 0) return 'green'
  return 'black'
}
